module.exports = __webpack_public_path__ + "static/media/inzynieria.b8bd2b9a.svg";